import { boot } from 'quasar/wrappers'
import { installSsrStateTransport } from 'booksprout-app'

/**
 * The SSR state transport, and the client-side hydration that pairs with it.
 *
 * This was `src/store/index.ts`, because Quasar 1 demanded a store factory and called
 * `replaceState` on whatever it returned -- so the transport rode along inside a Vuex-shaped shim.
 * Quasar 2 asks for no store at all, and a boot file is the earliest per-request hook there is, so
 * the shim is gone and this is a plain call.
 *
 * Listed FIRST in quasar.config.js, ahead of `bootstrap`: on the server it opens the request's store
 * context (every `defineState` read after it is per-request), and on the client it hydrates the
 * stores from `window.__INITIAL_STATE__` before anything reads them.
 *
 * `@quasar/ssr-helpers` serialises `ssrContext.state` into that global after the render, whether or
 * not the app has a store -- which is what makes the getter installed here work.
 */
export default boot(({ ssrContext }) => {
  installSsrStateTransport(void 0, ssrContext)
})
